import styled from '@emotion/styled';
import { Formik } from 'formik';
import { FormikHelpers } from 'formik/dist/types';
import { Plus } from 'lucide-react';
import React, { useCallback, useImperativeHandle, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import { AppDispatch } from 'store/store';
import UDFormInput from 'ud-form/components/input';
import UDButton from 'ud-ui/components/button';
import { StageV2 } from '../../../../../../domain/interfaces/stage';
import { UpsertStageTeamGroupParams } from '../../../../../../domain/repositories/tourneys-repository';
import { upsertStageTeamGroup } from '../../../../../../store/stages/stages.actions';

const CreateStageGroupFormWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
`;

export type CreateStageGroupFormHandle = {
  focus: () => void;
};

type CreateStageGroupFormProps = {
  stage: StageV2;
};

const CreateStageGroupForm = React.forwardRef<CreateStageGroupFormHandle, CreateStageGroupFormProps>(({ stage }, ref) => {
  const dispatch = useDispatch<AppDispatch>();
  const inputRef = useRef<HTMLInputElement>(null);
  const [isHighlighted, setIsHighlighted] = useState(false);

  useImperativeHandle(ref, () => ({
    focus: () => {
      inputRef.current?.focus();
      setIsHighlighted(true);
    },
  }));

  const initialValues: UpsertStageTeamGroupParams = {
    stageId: stage.id,
    name: '',
    teamIds: [],
  };

  const handleSubmit = useCallback(
    (values: UpsertStageTeamGroupParams, { resetForm }: FormikHelpers<UpsertStageTeamGroupParams>) => {
      if (!values.name.length) {
        return;
      }

      dispatch(upsertStageTeamGroup(values)).then(() => {
        resetForm();
      });
    },
    [dispatch],
  );

  return (
    <CreateStageGroupFormWrapper className="w-full">
      <Formik initialValues={initialValues} onSubmit={handleSubmit}>
        {(formProps) => (
          <form onSubmit={formProps.handleSubmit} className={'flex justify-between gap-5'}>
            <div>
              <UDButton variant={'primary'}>Таблица</UDButton>
            </div>
            <div className={'flex gap-5'}>
              <div
                className={`w-100 rounded-lg ${isHighlighted ? 'animate-highlight' : ''}`}
                onAnimationEnd={() => setIsHighlighted(false)}
              >
                <UDFormInput ref={inputRef} name="name" placeholder="Создать новую группу" />
              </div>
              <UDButton
                disabled={!formProps.values.name.length}
                type="submit"
                variant="primary"
                loading={formProps.isSubmitting}
                className={'whitespace-nowrap'}
              >
                <Plus size={20} />
                Создать группу
              </UDButton>
            </div>
          </form>
        )}
      </Formik>
    </CreateStageGroupFormWrapper>
  );
});

export default CreateStageGroupForm;
